import api from "./client";

// Notes hub: Projects and Contacts (Fan, 2026-10-16).
export const getNotebookEntries = (kind, params = {}) => api.get("/notebook", { params: { kind, ...params } });
export const getNotebookEntry = (entryId) => api.get(`/notebook/${entryId}`);
export const createNotebookEntry = (data) => api.post("/notebook", data);
export const updateNotebookEntry = (entryId, data) => api.patch(`/notebook/${entryId}`, data);
export const archiveNotebookEntry = (entryId) => api.delete(`/notebook/${entryId}`);
export const addNotebookNote = (entryId, note) => api.post(`/notebook/${entryId}/notes`, { note });
export const editNotebookNote = (entryId, noteId, note) =>
  api.patch(`/notebook/${entryId}/notes/${encodeURIComponent(noteId)}`, { note });
export const deleteNotebookNote = (entryId, noteId) =>
  api.delete(`/notebook/${entryId}/notes/${encodeURIComponent(noteId)}`);
